import Id from './Id';
import Customer from './Customer';
import GrossPrice from './GrossPrice';
import NetPrice from './NetPrice';
import Shop from './Shop';
import RepresentativeUser from './RepresentativeUser';
import Location from './Location';
import CreatedAt from './CreatedAt';


export const labels = {
  Id: 'Id',
  Customer: 'Vevő',
  GrossPrice: 'Bruttó ár',
  NetPrice: 'Nettó ár',
  Shop: 'Üzlet',
  RepresentativeUser: 'Képviselő',
  Location: 'Terület',
  CreatedAt: 'Dátum',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Customer',
}, {
  value: 'GrossPrice',
}, {
  value: 'CreatedAt'
}, {
  value: 'NetPrice',
}, {
  value: 'Shop',
}, {
  value: 'RepresentativeUser',
}, {
  value: 'Location',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'RepresentativeUser',
}, {
  value: 'Customer',
}, {
  value: 'Shop',
}, {
  value: 'Location',
}, {
  value: 'CreatedAt'
}, {
  value: 'NetPrice',
  fixed: true,
}, {
  value: 'GrossPrice',
  fixed: true,
}];

export const defaultSort = {
  prop: GrossPrice.propName,
  order: 'descending'
};

export default {
  Id,
  Customer,
  GrossPrice,
  NetPrice,
  Shop,
  RepresentativeUser,
  Location,
  CreatedAt
};
